import * as React from "react";

function SvgProfile(props) {
  return <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" {...props}><path d="M7 1.663a1.838 1.838 0 110 3.675 1.838 1.838 0 010-3.675zm0 7.875c2.599 0 5.338 1.277 5.338 1.837v.963H1.662v-.963c0-.56 2.738-1.838 5.337-1.838zM7 0a3.499 3.499 0 00-3.5 3.5C3.5 5.434 5.066 7 7 7s3.5-1.566 3.5-3.5S8.934 0 7 0zm0 7.875c-2.336 0-7 1.172-7 3.5V14h14v-2.625c0-2.328-4.664-3.5-7-3.5z" /></svg>;
}

export default SvgProfile;